import actionCreatorFactory from 'typescript-fsa';
import { KansatsuKirokuSubdiv } from '../../../models/KansatsuKirokuSubdiv';
// actionのprefixを設定
const actionCreator = actionCreatorFactory('kansatsuKirokuSubdiv');

const fetchRecords = actionCreator.async<
  {
    koujiBangou: string
  }, // started: parameter type
  {
    Items: KansatsuKirokuSubdiv[];
  }, // done: success type
  {
    error: string
  } // failed: error type
  >('FETCH_RECORDS');

const getRecord = actionCreator.async<
  {
    koujiBangou: string;
    key: string;
  }, // started: parameter type
  {
    Item: KansatsuKirokuSubdiv;
  }, // done: success type
  {
    error: string
  } // failed: error type
  >('GET_RECORD');

const postRecord = actionCreator.async<
  {
    item: KansatsuKirokuSubdiv;
  }, // started: parameter type
  {
    item: KansatsuKirokuSubdiv;
  }, // done: success type
  {
    error: string
  } // failed: error type
  >('POST_RECORD');

const resetRecord = actionCreator('RESET_RECORD');

// 最新の岩石グループ取得アクション
const getLatestRockMassGroup = actionCreator.async<
  {
    koujiBangou: string;
  }, // started: parameter type
  {
    rockMassGroup: string | undefined; // 成功時は岩石グループ(存在しない場合undefined)
  }, // done: success type
  {
    error: string
  } // failed: error type
>('GET_LATEST_ROCK_MASS_GROUP');


export {
  fetchRecords,
  getRecord,
  postRecord,
  resetRecord,
  getLatestRockMassGroup
};



// WEBPACK FOOTER //
// ./src/redux/modules/kansatsuKirokuSubdiv/actions.ts